import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import { Delete } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CreatePopupOffer from "./CreatePopupOffer";
import SegmentationModal from "./SegmentationModal";
import TriggerIntentModal from "./TriggerIntentModal";
import PopupStatsModal from "./PopupStatsModal";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0}>{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}</IconButton>
      <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0}>{theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}</IconButton>
      <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>{theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}</IconButton>
      <IconButton onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}</IconButton>
    </Box>
  );
}

const fmtDate = (v) => (v ? String(v).replace("T", " ").slice(0, 16) : "-");

const PopupOffers = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [showSegmentation, setShowSegmentation] = useState(false);
  const [showTriggers, setShowTriggers] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [packages, setPackages] = useState([]);

  const resolvePkg = (row) => {
    const id = row.boosterPackageId || row.booster_package_id || row.packageId || row.package_id;
    let p = id ? packages.find((x) => Number(x?.id) === Number(id)) : null;
    if (!p) {
      // fall back to the buy-coins CTA link (carries the long packageId)
      const m = /[?&]packageId=([^&]+)/.exec(row.ctaLink || row.cta_link || "");
      if (m) p = packages.find((x) => String(x?.packageId) === String(m[1]));
    }
    return p;
  };

  const packageText = (row) => {
    const p = resolvePkg(row);
    return p ? `$${p?.purchase_price}` : "None";
  };

  // Yes = the reward is gated behind a package purchase (or the offer is package-only); No = direct reward or plain popup
  const buyPackageText = (row) => {
    const mode = row.rewardMode || row.reward_mode;
    const t = row.rewardType || row.reward_type;
    if (mode === "on_purchase") return "Yes";
    if (!t) {
      const id = row.packageId || row.package_id;
      if (id || /[?&]packageId=/.test(row.ctaLink || row.cta_link || "")) return "Yes";
    }
    return "No";
  };

  const rewardText = (row) => {
    const t = row.rewardType || row.reward_type;
    if (!t) return "No Reward";
    if (t === "SC") return `${row.rewardSc || 0} SC (${row.rewardMultiplier || 1}x)`;
    if (t === "GC") return `${row.rewardGc || 0} GC`;
    if (t === "FREE_SPIN") return `Free Spins (${row.rewardSpinCount || 0} × ${(row.rewardSpinValue || 0) / 100} SC)`;
    if (t === "RAF_BOOST") return `RAF Boost (+${row.rewardRafPercent || 0}%)`;
    if (t === "WOF" || t === "WOF_RESET") return "Wheel of Fortune";
    if (t === "BOOSTER") { const p = resolvePkg(row); return `Booster${p ? ` ($${p.purchase_price})` : ""}`; }
    return t;
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  useEffect(() => {
    fetchOffers();
    (async () => {
      try {
        const res = await getAllData(`${endPoints.api.GET_PACKAGE}`);
        if (res?.status === "success") setPackages(res?.data || []);
      } catch (e) { console.error(e); }
    })();
  }, []);

  const fetchOffers = async () => {
    setIsLoading(true);
    try {
      const response = await getAllData(`${endPoints.api.POPUP_OFFER_ALL}`);
      if (response.status === "success") setRows(response.data || []);
      else ErrorToast("Failed to fetch pop-up offers");
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteOffer = (id) => {
    setIsLoading(true);
    deleteData(`${endPoints.api.POPUP_OFFER_DELETE}/${id}`)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast("Pop-up offer deleted");
          fetchOffers();
        } else ErrorToast(response.data.message);
      })
      .catch((err) => { console.error(err); setIsLoading(false); });
  };

  const onClose = () => { setShowForm(false); fetchOffers(); };

  return (
    <div className="main">
      <Toaster />
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div id="Sportbook" style={{ padding: "0px" }}>
        <div className="container-fluid bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #444" }}>
                <h3 className="mb-2" style={{ fontFamily: "ArticulatCF-Bold" }}>Pop-up Offers</h3>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <Button variant="primary"
                    style={{ height: "fit-content", fontWeight: 600, padding: "8px 20px", borderRadius: 4, marginBottom: 12 }}
                    onClick={() => setShowStats(true)}>
                    Popup Stats
                  </Button>
                  <Button variant="primary"
                    style={{ height: "fit-content", fontWeight: 600, padding: "8px 20px", borderRadius: 4, marginBottom: 12 }}
                    onClick={() => setShowTriggers(true)}>
                    Trigger / Intent
                  </Button>
                  <Button variant="primary"
                    style={{ height: "fit-content", fontWeight: 600, padding: "8px 20px", borderRadius: 4, marginBottom: 12 }}
                    onClick={() => setShowSegmentation(true)}>
                    Segmentation
                  </Button>
                  <Button variant="primary"
                    style={{ height: "fit-content", fontWeight: 600, padding: "8px 20px", borderRadius: 4, marginBottom: 12 }}
                    onClick={() => { setEditData({}); setShowForm(true); }}>
                    Add Offer
                  </Button>
                </div>
              </div>
            </div>

            <CreatePopupOffer open={showForm} onClose={onClose} editData={editData} />
            <SegmentationModal open={showSegmentation} onClose={() => setShowSegmentation(false)} />
            <TriggerIntentModal open={showTriggers} onClose={() => setShowTriggers(false)} />
            <PopupStatsModal open={showStats} onClose={() => setShowStats(false)} />

            <div className="container-fluid table-custom">
              <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                <div className="col-md-12">
                  <TableContainer component={Paper}>
                    <Table className="c_table" size="small" stickyHeader sx={{ minWidth: 500 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">Name</TableCell>
                          <TableCell align="center">Template</TableCell>
                          <TableCell align="center">Trigger</TableCell>
                          <TableCell align="center">Reward</TableCell>
                          <TableCell align="center">Purchase Required</TableCell>
                          <TableCell align="center">Package</TableCell>
                          <TableCell align="center">Priority</TableCell>
                          <TableCell align="center">Max Shows</TableCell>
                          <TableCell align="center">From</TableCell>
                          <TableCell align="center">To</TableCell>
                          <TableCell align="center">Active</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0 ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : rows).map((row, i) => (
                          <TableRow key={row.id || i}>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">{row.template}</TableCell>
                            <TableCell align="center">{row.triggerEvent || row.trigger_event}</TableCell>
                            <TableCell align="center">{rewardText(row)}</TableCell>
                            <TableCell align="center">{buyPackageText(row)}</TableCell>
                            <TableCell align="center">{packageText(row)}</TableCell>
                            <TableCell align="center">{row.priority}</TableCell>
                            <TableCell align="center">{row.maxPerDay ?? row.max_per_day ?? "-"}</TableCell>
                            <TableCell align="center">{fmtDate(row.activeFrom || row.active_from)}</TableCell>
                            <TableCell align="center">{fmtDate(row.activeTo || row.active_to)}</TableCell>
                            <TableCell align="center">{(row.active ?? false) ? "On" : "Off"}</TableCell>
                            <TableCell align="center">
                              <div className="row">
                                <div className="col-5">
                                  <AiOutlineEdit size={20} style={{ cursor: "pointer" }}
                                    onClick={() => { setEditData(row); setShowForm(true); }} />
                                </div>
                                <div className="col-5">
                                  <span onClick={() => deleteOffer(row.id)} style={{ cursor: "pointer" }}><Delete /></span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (<TableRow style={{ height: 53 * emptyRows }}><TableCell colSpan={12} /></TableRow>)}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                            colSpan={12}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{ inputProps: { "aria-label": "rows per page" }, native: true }}
                            onPageChange={(e, p) => setPage(p)}
                            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupOffers;
